import React, { useState } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Box, Card } from '@mui/material'
/* TODO: remove these as these was used to redirect to jetpac engine
import { useFlagsStatus } from '@unleash/proxy-client-react'
import useOrbitFlag from 'hooks/useOrbitFlag'
*/
import { LocationState } from 'types/routerLocation'

import CaptchaFooter from './components/CaptchaFooter'
import LoginForm from './components/LoginForm'
import LogInHeader from './components/LogInHeader'
import LogInNav from './components/LogInNav'
import OtpForm from './components/OtpForm'

let toggledWarningFromPrevLocation = false

export default function LogIn() {
  /* TODO: remove these as these was used to redirect to jetpac engine
  const redirectToEngineFlag = useOrbitFlag('redirect-to-engine')
  const flags = useFlagsStatus()
  */

  // reads the redirect error, if any, and toasts it to the client
  const location = useLocation() as LocationState
  if (location?.state?.reason && !toggledWarningFromPrevLocation) {
    toggledWarningFromPrevLocation = true
    toast.error(location.state.reason)
  }

  // initialize recaptcha
  const { executeRecaptcha } = useGoogleReCaptcha()

  // Switch between Otp and Email
  const [email, setEmail] = useState('')

  const onReset = () => {
    setEmail('')
  }

  const OrbitHeader = () => (
    <Box
      sx={{
        width: '50vw',
        color: '#FFFFFF',
        fontStyle: 'roboto',
        fontWeight: 900,
        fontSize: '4em',
        maxWidth: '450px',
        margin: '0 auto'
      }}
    >
      Reinventing the B2B telco experience.
    </Box>
  )

  const LogInPageBody = () => (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100vw'
      }}
    >
      <OrbitHeader />
      <Box
        display='flex'
        justifyContent='flex-end'
        sx={{
          marginRight: '75px',
          width: '500px'
        }}
      >
        <Card>
          <Box
            display='flex'
            flexDirection='column'
            justifyContent='space-between'
            alignItems='center'
            sx={{
              height: '75vh',
              maxWidth: '450px',
              overflowY: 'hidden',
              padding: `36px 2rem`
            }}
          >
            <Box
              sx={{
                width: '370px',
                overflowY: 'auto'
              }}
            >
              <LogInHeader />
              {!email ? (
                <LoginForm
                  setEmail={setEmail}
                  executeRecaptcha={executeRecaptcha}
                />
              ) : (
                <OtpForm
                  email={email}
                  executeRecaptcha={executeRecaptcha}
                  onReset={onReset}
                />
              )}
              <CaptchaFooter />
            </Box>
          </Box>
        </Card>
      </Box>
    </Box>
  )

/* TODO: used to redirect to jetpac engine
  const RedirectPageBody = () => (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100vw'
      }}
    >
      <Box
        sx={{
          width: '70vw',
          color: '#FFFFFF',
          fontWeight: 800,
          fontSize: '2.5em',
          margin: '0 auto'
        }}
      >
        We have moved to Engine Jetpac.
        <br />
        Click <a href='https://engine.jetpacglobal.com/'>here</a> to redirect.
      </Box>
    </Box>
  )

  return !flags.flagsReady ? (
    <></>
  ) : redirectToEngineFlag ? (
    <Box
      className='background'
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='space-evenly'
      height='100vh'
      sx={{
        padding: '1rem'
      }}
    >
      <RedirectPageBody />
    </Box>
  ) : (
*/
  return (
    <Box
      className='background'
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='space-evenly'
      height='100vh'
      sx={{
        padding: '1rem'
      }}
    >
      <LogInNav />
      <LogInPageBody />
    </Box>
  )
}
